export default function footer() {
	Array.from(document.querySelectorAll(".footer__accordion__section__trigger")).forEach(
		(trigger) => trigger.addEventListener("click", (e) => toggleFooterAccordion(e))
	);
}

function toggleFooterAccordion(e) {
	Array.from(document.querySelectorAll(".footer-accordion-section ul")).forEach(
		(section) => {
			if (section.getAttribute("id") !== e.target.getAttribute("data-target")) {
				section.classList.add("h-0");
				section.classList.remove("pt-3", "pb-5");
			}
		}
	);
	Array.from(document.querySelectorAll(".footer__section__toggle")).forEach(
		(sectionToggle) => {
			if (sectionToggle.getAttribute("id") !== e.target.getAttribute("data-toggle")) {
				sectionToggle.setAttribute(
					"src",
					"https://cdn.shopify.com/s/files/1/0572/4798/9919/files/whiteplus.svg?v=1624630681"
				);
			}
		}
	);
	if (window.innerWidth < 1280) {
		const targetId = e.target.getAttribute("data-target");
		const imgTargetId = e.target.getAttribute("data-toggle");
		const subMenu = document.querySelector("#" + targetId + "  ul");
		const imgItem = document.querySelector("#" + imgTargetId);

		if (subMenu.classList.contains("footer__section-active")) {
			imgItem.setAttribute(
				"src",
				"https://cdn.shopify.com/s/files/1/0572/4798/9919/files/whiteplus.svg?v=1624630681"
			);
			subMenu.classList.add("h-0");
			subMenu.classList.remove("pt-3", "pb-5", "footer__section-active");
			imgItem.classList.remove("footer__section__toggle-active");
		} else {
			imgItem.setAttribute(
				"src",
				"https://cdn.shopify.com/s/files/1/0572/4798/9919/files/whiteminus.svg?v=1624631126"
			);
			subMenu.classList.remove("h-0");
			subMenu.classList.add("pt-3", "pb-5", "footer__section-active");
			imgItem.classList.add("footer__section__toggle-active");
		}
	}
}

document.addEventListener("DOMContentLoaded", footer());
